module.exports = __webpack_public_path__ + "static/media/arst.91013f67.svg";